import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatAccordion } from '@angular/material/expansion';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { ActivatedRoute } from '@angular/router';
import { LookupService } from '@app/modules/maintenance/services/lookup.service';
import { ApiResult } from '@app/shared/model/apiresult';
import { ILookup } from '@app/shared/model/lookup';
import { Guid } from 'guid-typescript';
import { Messages } from 'src/app/modules/compliance/constants/messages';
import { ELookup } from '../../constants/eLookup';
import { emptyOfficialVisit, emptyOfficialVisitOccurence, emptyStudentHighSchool } from '../../constants/prepareEmptyObject';
import { IOfficialVisit, IStudentOfficialVisitOccurence } from '../../model/officialvisit';
import { OfficialVisitService } from '../../services/official-visit.service';
import { environment as env } from '@environments/environment'
import { IStudentHighSchool, IStudentProspectGrid } from '@app/modules/prospective/model/studenthighschool';
import { InstitutionSearchDialog } from '@app/modules/shared/component/institution-search/institution-search.component';
import { StudentHighSchoolService } from '@app/modules/prospective/services/student-highschool.service';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';

@Component({
    selector: 'official-visit',
    templateUrl: './official-visit.component.html'
})
export class OfficialVisitComponent implements OnInit {
    @Input() WriteCompliance: boolean = false;
    institutionSearchDialogRef: any;
    studentID: Guid;
    NcaaId: string;
    public studentOfficialVisitFormGroup: UntypedFormGroup;
    public studentOfficialVisit: IOfficialVisit = emptyOfficialVisit();
    public studentOfficialVisitOccurence: IStudentOfficialVisitOccurence = emptyOfficialVisitOccurence();
    public studentOfficialVisitOccurenceList: IStudentOfficialVisitOccurence[] = [];

    public officialVisitReasonList: ILookup[];
    public letterStatusList: ILookup[];

    displayedColumns: string[] = ['OfficialVisitDate', 'Reason', 'action'];
    highSchoolDisplayedColumns: string[];

    dataSource = new MatTableDataSource<IStudentOfficialVisitOccurence>();
    @ViewChild(MatAccordion) accordion: MatAccordion;
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild('highSchoolPaginator') highSchoolPaginator: MatPaginator;

    // High School Information.
    public studentHighSchoolFormGroup: UntypedFormGroup;
    highSchoolDataSource = new MatTableDataSource<IStudentProspectGrid>();
    public studentHighSchool: IStudentHighSchool = emptyStudentHighSchool();

    constructor(
        private _snackBar: MatSnackBar,
        private _formBuilder: UntypedFormBuilder,
        private _route: ActivatedRoute,
        private _lookupservice: LookupService,
        private _officialvisitservice: OfficialVisitService,
        private _studenthighschoolservice: StudentHighSchoolService,
        private dialog: MatDialog) {
        //Form Group Initiation.
        this.fillForm(this.studentOfficialVisit);
        this.fillHighSchoolForm(this.studentHighSchool);
    }
    ngOnInit() {
        this.highSchoolDisplayedColumns = this.WriteCompliance ? ['institutionCode', 'institutionDescription', 'isCurrent', 'action'] : ['institutionCode', 'institutionDescription', 'isCurrent'];
        this._route.queryParams.subscribe(params => {
            this.studentID = params.id;
        });
        this.getActiveLookups(ELookup.OfficialVisitReason);
        this.getActiveLookups(ELookup.LetterStatus);

        if (this.studentID != null) {
            this.get();
            this.getHighSchoolInformation();
            this.getNcaaId();
        }
    }
    private getActiveLookups(tableName: string) {
        this._lookupservice.getActiveLookups(tableName).subscribe((result: ApiResult<ILookup[]>) => {
            if (result.validationErrors == null) {
                switch (tableName) {
                    case ELookup.OfficialVisitReason:
                        this.officialVisitReasonList = result.value;
                        break;
                    case ELookup.LetterStatus:
                        this.letterStatusList = result.value;
                        break;
                    default:
                        break;
                }
            }
        }, error => console.error(error));
    }
    private fillForm(studentOfficialVisitInfo: IOfficialVisit) {
        this.studentOfficialVisitFormGroup = this._formBuilder.group(
            {
                studentId: [studentOfficialVisitInfo.studentId],
                tenantId: [studentOfficialVisitInfo.tenantId],
                studentOfficialVisitId: [studentOfficialVisitInfo.studentOfficialVisitId],
                transcriptRecievedDate: [studentOfficialVisitInfo.transcriptRecievedDate],
                registeredNCAA: [studentOfficialVisitInfo.registeredNCAA],
            });
    }
    public add() {
        this.studentOfficialVisitOccurence.occurenceReason = this.officialVisitReasonList.filter(t => t.id === this.studentOfficialVisitOccurence.occurenceReasonId)[0].description;
        this.studentOfficialVisitOccurence.studentOfficialVisitId = this.studentOfficialVisit.studentOfficialVisitId;
        if (this.studentOfficialVisitOccurence.studentOfficialVisitOccurenceId != null) {
            this._officialvisitservice.updateOfficialVisitOccurence(this.studentOfficialVisitOccurence).subscribe((result: ApiResult<number>) => {
                if (result.statusCode == 200) {
                    this.notify(Messages.OfficialVisitSaved);
                    this.studentOfficialVisitOccurence = emptyOfficialVisitOccurence();
                    this.getOccurence();
                }
                else {
                    this.notifyWarnings(result.validationErrors);
                }
            }, error => console.error(error));
        }
        else {
            this.studentOfficialVisitOccurence.studentOfficialVisitOccurenceId = Guid.createEmpty().toJSON().value;
            this._officialvisitservice.createOfficialVisitOccurence(this.studentOfficialVisitOccurence).subscribe((result: ApiResult<number>) => {
                if (result.statusCode == 200) {
                    this.notify(Messages.OfficialVisitSaved);
                    this.studentOfficialVisitOccurence = emptyOfficialVisitOccurence();
                    this.getOccurence();
                }
                else {
                    this.notifyWarnings(result.validationErrors);
                }
            }, error => console.error(error));
        }
    }
    public edit(obj: IStudentOfficialVisitOccurence) {
        this.studentOfficialVisitOccurence = obj;
    }
    public delete(id: Guid) {
        this._officialvisitservice.deleteOfficialVisitOccurence(id).subscribe((result: ApiResult<any>) => {
            if (result.validationErrors == null) {
                this.getOccurence();
                this.studentOfficialVisitOccurence = emptyOfficialVisitOccurence();
            }
        }, error => console.error(error));
    }
    private get() {
        this._officialvisitservice.get(this.studentID).subscribe((result: ApiResult<IOfficialVisit>) => {
            if (result.validationErrors == null && result.value != null) {
                this.studentOfficialVisit = result.value;
                this.studentOfficialVisitOccurenceList = this.studentOfficialVisit.studentOfficialVisitOccurence;
                this.dataSource = new MatTableDataSource<IStudentOfficialVisitOccurence>(this.studentOfficialVisit.studentOfficialVisitOccurence);
                this.dataSource.paginator = this.paginator;
                this.fillForm(this.studentOfficialVisit);
            }
        }, error => console.error(error));
    }
    private getNcaaId()
    {
        this._officialvisitservice.getNcaaId(this.studentID).subscribe((result: ApiResult<string>) => {
            if (result.validationErrors == null && result.value != null) {
                this.NcaaId = result.value;
            }
        }, error => console.error(error));
    }
    private getOccurence() {
        this._officialvisitservice.getOccurence(this.studentID).subscribe((result: ApiResult<IStudentOfficialVisitOccurence[]>) => {
            if (result.validationErrors == null && result.value != null) {
                this.studentOfficialVisitOccurenceList = result.value;
                this.dataSource = new MatTableDataSource<IStudentOfficialVisitOccurence>(result.value);
                this.dataSource.paginator = this.paginator;
            }
        }, error => console.error(error));
    }
    public onSubmit() {
        this.studentOfficialVisit = this.studentOfficialVisitFormGroup.value as IOfficialVisit;
        this.studentOfficialVisit.tenantId = Guid.parse(env.tenantId).toJSON().value;
        this.studentOfficialVisit.studentOfficialVisitOccurence = this.studentOfficialVisitOccurenceList;
        this.studentOfficialVisit.studentId = this.studentID;
        if (this.studentOfficialVisit.studentOfficialVisitId !== null) {
            this._officialvisitservice.put(this.studentOfficialVisit).subscribe((result: ApiResult<number>) => {
                if (result.statusCode == 200) {
                    this.notify(Messages.OfficialVisitSaved);
                    this.get();
                }
                else {
                    this.notifyWarnings(result.validationErrors);
                }
            }, error => console.error(error));
        }
        else {
            this.studentOfficialVisit.studentOfficialVisitId = Guid.createEmpty().toJSON().value;
            this._officialvisitservice.post(this.studentOfficialVisit).subscribe((result: ApiResult<number>) => {
                if (result.statusCode == 200) {
                    this.notify(Messages.OfficialVisitSaved);
                    this.get();
                }
                else {
                    this.studentOfficialVisit.studentOfficialVisitId = null;
                    this.notifyWarnings(result.validationErrors);
                }
            }, error => console.error(error));
        }
    }

    /* High Shool Information */
    private getHighSchoolInformation() {
        this._studenthighschoolservice.get(this.studentID).subscribe((result: ApiResult<IStudentProspectGrid[]>) => {
            if (result.validationErrors == null && result.value != null) {
                this.highSchoolDataSource = new MatTableDataSource<IStudentProspectGrid>(result.value);
                this.highSchoolDataSource.paginator = this.highSchoolPaginator;
            }
        }, error => console.error(error));
    }
    private getHighShcoolById(highSchoolId: Guid) {
        this._studenthighschoolservice.getById(highSchoolId).subscribe((result: ApiResult<IStudentHighSchool>) => {
            if (result.validationErrors == null && result.value != null) {
                this.studentHighSchool = result.value;
                this.fillHighSchoolForm(this.studentHighSchool);
            }
        }, error => console.error(error));
    }
    private deleteHighSchoolById(highSchoolId: Guid) {
        this._studenthighschoolservice.delete(highSchoolId).subscribe((result: ApiResult<any>) => {
            if (result.validationErrors == null) {
                this.getHighSchoolInformation();
            }
        }, error => console.error(error));
    }
    cancel() {
        this.studentHighSchool = emptyStudentHighSchool();
        this.fillHighSchoolForm(this.studentHighSchool);
    }
    public editHighSchool(highSchoolId: Guid) {
        this.getHighShcoolById(highSchoolId);
    }
    public deleteHighSchool(highSchoolId: Guid) {
        this.deleteHighSchoolById(highSchoolId);
        this.cancel();
    }
    openDialog() {
        this.institutionSearchDialogRef = this.dialog.open(InstitutionSearchDialog, { width: '70%', height: '70%', data: { searchText: this.studentHighSchoolFormGroup.controls["institutionDescription"].value, studentID: this.studentID, isHighSchool: true, title: 'High School Search' } });
        this.institutionSearchDialogRef.afterClosed().subscribe((result: any) => {
            if (result) {
                this.studentHighSchoolFormGroup.get('institutionDescription').setValue(result["description"]);
                this.studentHighSchoolFormGroup.get('highSchoolInstitutionId').setValue(result["id"]);
                this.studentHighSchool.highSchoolInstitutionId = result['id'];
                this.studentHighSchool.institutionDescription = result['description'];
            }
        });
    }
    public onSubmitHighSchool() {
        this.studentHighSchool = this.studentHighSchoolFormGroup.value as IStudentHighSchool;
        this.studentHighSchool.tenantId = Guid.parse(env.tenantId).toJSON().value;
        this.studentHighSchool.studentId = this.studentID;
        if (this.studentHighSchool.studentHighSchoolId !== null) {
            this._studenthighschoolservice.put(this.studentHighSchool).subscribe((result: ApiResult<number>) => {
                if (result.statusCode == 200) {
                    this.cancel();
                    this.notify(Messages.StudentHighSchoolSaved);
                    this.getHighSchoolInformation();
                }
                else {
                    this.notifyWarnings(result.validationErrors);
                }
            }, error => console.error(error));
        }
        else {
            this.studentHighSchool.studentHighSchoolId = Guid.createEmpty().toJSON().value;
            this._studenthighschoolservice.post(this.studentHighSchool).subscribe((result: ApiResult<Guid>) => {
                if (result.statusCode == 200) {
                    this.studentHighSchoolFormGroup.get('studentHighSchoolId').setValue(result.value);
                    this.cancel();
                    this.notify(Messages.StudentHighSchoolSaved);
                    this.getHighSchoolInformation();
                }
                else {
                    this.studentHighSchool.studentHighSchoolId = null;
                    this.notifyWarnings(result.validationErrors);
                }
            }, error => console.error(error));
        }
    }
    private fillHighSchoolForm(studentHighSchoolInfo: IStudentHighSchool) {
        this.studentHighSchoolFormGroup = this._formBuilder.group(
            {
                studentId: [studentHighSchoolInfo.studentId],
                tenantId: [studentHighSchoolInfo.tenantId],
                studentHighSchoolId: [studentHighSchoolInfo.studentHighSchoolId],
                highSchoolInstitutionId: [studentHighSchoolInfo.highSchoolInstitutionId],
                institutionDescription: [studentHighSchoolInfo.institutionDescription],
                isCurrent: [studentHighSchoolInfo.isCurrent],
            });
    }
    /* High School Information */
    notifyWarnings(message: string[]) {
        let snackBarRef = this._snackBar.open(message[0], "Close", {
            duration: 5000,
            panelClass: ['error-border']
        });
        snackBarRef.afterDismissed().subscribe(() => {
        });
    }
    notify(message:string) {
        let snackBarRef = this._snackBar.open(message, "Close", {
            duration: 2000,
        });
        snackBarRef.afterDismissed().subscribe(() => {
        });
    }

    evalBind(data:ILookup,currentValue:number){
        if(data.id==currentValue){
            return true;
        }
      return !data.disabled;
    }
}